"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginRenewalService = void 0;
class LoginRenewalService {
    constructor(authServiceWeConnectFag, identityDataClient) {
        this.authServiceWeConnectFag = authServiceWeConnectFag;
        this.identityDataClient = identityDataClient;
        this.EXPIRATION_DELTA_MS = (5 * 60 - 10) * 1000;
    }
    async reloginIfNecessary(redirectUrl) {
        if (await this.loginIsRequired()) {
            await this.relogin(redirectUrl);
        }
    }
    async relogin(redirectUrl) {
        await this.authServiceWeConnectFag.login('login', redirectUrl);
    }
    async loginIsRequired() {
        try {
            const currentTimestampMs = Date.now();
            const { lastAuthenticationDate } = await this.identityDataClient.getIdentityData();
            return currentTimestampMs >= lastAuthenticationDate + this.EXPIRATION_DELTA_MS;
        }
        catch (e) {
            return false; // has to be false to prevent endless loop
        }
    }
}
exports.LoginRenewalService = LoginRenewalService;
//# sourceMappingURL=LoginRenewalService.js.map